import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { SelectOption } from './select-field.config';

@Component({
  selector: 'select-field',
  imports: [ReactiveFormsModule, CommonModule],
  templateUrl: './select-field.component.html',
  styleUrl: './select-field.component.scss'
})
export class SelectFieldComponent implements OnInit{
  @Input() label?: string;
  @Input() options: (SelectOption)[] = [];
  @Input() selectFormControl!: FormControl
  @Input() readonly:boolean = false
  @Output() valueChange = new EventEmitter<string>();
  @Output() selectionChange = new EventEmitter<string>();

  isOpen = false;
  readonly String = String;

  get hasDots(): boolean {
    return this.options.some(o => o.dotClass !== undefined);
  }

  get selectedOption(): SelectOption | undefined {
    return this.options.find(o => String(o.key) === String(this.selectFormControl?.value));
  }

  ngOnInit(): void {
    if(this.readonly){
      this.selectFormControl.disable({ emitEvent: false })
    }
  }

  onValueChange(value: any): void {    
    this.valueChange.emit(value.value);
    this.selectionChange.emit(value.value);
  }

  toggleDropdown(): void {
    if (!this.selectFormControl?.disabled) {
      this.isOpen = !this.isOpen;
      this.selectFormControl?.markAsTouched();
    }
  }

  pickOption(option: SelectOption): void {
    this.selectFormControl.setValue(option.key);
    this.isOpen = false;
    this.valueChange.emit(String(option.key));
    this.selectionChange.emit(String(option.key));
  }
}
